export type SortOptionId = 'newest' | 'oldest' | 'az' | 'za' | string;

export const DEFAULT_SORT_OPTIONS: Array<{
  id: SortOptionId;
  label: string;
}> = [
  { id: 'newest', label: 'Newest first' },
  { id: 'oldest', label: 'Oldest first' },
  { id: 'az', label: 'A-Z' },
  { id: 'za', label: 'Z-A' },
];

// helper for UI sizing
export const getLongestSortLabel = (options: { label: string }[]): string =>
  options.reduce((longest, o) => o.label.length > longest.length ? o.label : longest, '');
